export const NETWORK_MONITORING_PERMISSIONS = ['FTTS', 'MPBN', 'OTN', 'IPRAN'];

// Inventory management permissions
export const INVENTORY_MANAGEMENT_PERMISSIONS = ['Inventory', 'Leased Fiber Pair'];

// User management permissions
export const USER_MANAGEMENT_PERMISSIONS = ['User Management'];

// Partner network permissions
export const PARTNER_NETWORK_PERMISSIONS = ['Partner Network'];

// KMZ permissions
export const KMZ_PERMISSIONS = ['KMZ'];

// Ring planning permissions
export const RING_PLANNING_PERMISSIONS = ['Ring Planning'];

// Fiber Pop List permissions
export const FIBER_POP_LIST_PERMISSIONS = ['Fiber Pop List'];

/** Canonical FE permission; include aliases created in some tenants' DB. */
export const APPROVAL_PERSONS_SYSTEM_INVOICE_MANAGEMENT_PERMISSIONS = [
  'Approval Persons System Invoice Management',
  'System Approval Persons Invoice Management',
];

export const hasAnyPermission = (permissionNames, requiredPermissions) => {
  return requiredPermissions.some((permission) => permissionNames.includes(permission));
};

export const hasApprovalPersonsSystemInvoiceManagementAccess = (permissionNames) =>
  hasAnyPermission(permissionNames || [], APPROVAL_PERSONS_SYSTEM_INVOICE_MANAGEMENT_PERMISSIONS);

export const MANAGE_INVOICE_APPROVER_ASSIGNMENTS = 'Manage Invoice Approver Assignments';
export const APPROVE_INVOICE_APPROVER_ASSIGNMENTS = 'Approve Invoice Approver Assignments';

export const INVOICE_APPROVER_ASSIGNMENT_CONFLICT_PAIR = [
  MANAGE_INVOICE_APPROVER_ASSIGNMENTS,
  APPROVE_INVOICE_APPROVER_ASSIGNMENTS,
];

export const hasManageInvoiceApproverAssignmentsAccess = (permissionNames) =>
  permissionNames?.includes(MANAGE_INVOICE_APPROVER_ASSIGNMENTS);

export const hasApproveInvoiceApproverAssignmentsAccess = (permissionNames) =>
  permissionNames?.includes(APPROVE_INVOICE_APPROVER_ASSIGNMENTS);

export const hasInvoiceApproverAssignmentsModuleAccess = (permissionNames) =>
  hasManageInvoiceApproverAssignmentsAccess(permissionNames) ||
  hasApproveInvoiceApproverAssignmentsAccess(permissionNames);

export const MANAGE_SYSTEM_INVOICE_APPROVER_ASSIGNMENTS =
  'Manage System Invoice Approver Assignments';
export const APPROVE_SYSTEM_INVOICE_APPROVER_ASSIGNMENTS =
  'Approve System Invoice Approver Assignments';

export const SYSTEM_INVOICE_APPROVER_ASSIGNMENT_CONFLICT_PAIR = [
  MANAGE_SYSTEM_INVOICE_APPROVER_ASSIGNMENTS,
  APPROVE_SYSTEM_INVOICE_APPROVER_ASSIGNMENTS,
];

export const hasManageSystemInvoiceApproverAssignmentsAccess = (permissionNames) =>
  permissionNames?.includes(MANAGE_SYSTEM_INVOICE_APPROVER_ASSIGNMENTS);

export const hasApproveSystemInvoiceApproverAssignmentsAccess = (permissionNames) =>
  permissionNames?.includes(APPROVE_SYSTEM_INVOICE_APPROVER_ASSIGNMENTS);

export const hasSystemInvoiceApproverAssignmentsModuleAccess = (permissionNames) =>
  hasManageSystemInvoiceApproverAssignmentsAccess(permissionNames) ||
  hasApproveSystemInvoiceApproverAssignmentsAccess(permissionNames);

export const hasConflictingSystemInvoiceApproverAssignmentPermissions = (permissionNames) => {
  const names = permissionNames || [];
  return (
    names.includes(MANAGE_SYSTEM_INVOICE_APPROVER_ASSIGNMENTS) &&
    names.includes(APPROVE_SYSTEM_INVOICE_APPROVER_ASSIGNMENTS)
  );
};

export const LOGIN_LOCKOUT_MANAGEMENT_PERMISSIONS = ['Login Lockout Management'];

export const hasLoginLockoutManagementAccess = (permissionNames) =>
  hasAnyPermission(permissionNames || [], LOGIN_LOCKOUT_MANAGEMENT_PERMISSIONS);

export const hasConflictingInvoiceApproverAssignmentPermissions = (permissionNames) => {
  const names = permissionNames || [];
  return (
    names.includes(MANAGE_INVOICE_APPROVER_ASSIGNMENTS) &&
    names.includes(APPROVE_INVOICE_APPROVER_ASSIGNMENTS)
  );
};

export const getPermissionNamesFromGroupPermissions = (groups) => {
  const names = new Set();
  (groups || []).forEach((group) => {
    const perms = group.permissions || [];
    perms.forEach((p) => {
      const n = typeof p === 'string' ? p : p?.name;
      if (n) {
        names.add(n);
      }
    });
  });
  return [...names];
};

export const hasAllPermissions = (permissionNames, requiredPermissions) => {
  return requiredPermissions.every((permission) => permissionNames.includes(permission));
};

export const getAvailablePermissions = (permissionNames, availablePermissions) => {
  return availablePermissions.filter((permission) => permissionNames.includes(permission));
};

export const hasNetworkMonitoringPermissions = (permissionNames) => {
  return hasAnyPermission(permissionNames, NETWORK_MONITORING_PERMISSIONS);
};

export const getAvailableNetworkMonitoringPermissions = (permissionNames) => {
  return getAvailablePermissions(permissionNames, NETWORK_MONITORING_PERMISSIONS);
};
